import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';

// Componente para monitorar a inatividade e redirecionar para a tela de descanso
const IdleMonitor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { idleTime, MAX_IDLE_TIME } = useApp();

  // Lista de rotas que não devem ser redirecionadas por inatividade
  const protectedRoutes = [
    // Rotas administrativas
    '/admin-login',
    '/admin/mensalistas',
    '/admin/sorteio',
    '/admin/agenda',
    
    // Rotas críticas para clientes
    '/checkout'
  ];
  
  // Verifica se a rota atual é uma rota protegida contra redirecionamento
  const isProtectedRoute = protectedRoutes.some(route => location.pathname.startsWith(route));

  // Efeito para monitorar inatividade e redirecionar para a tela de descanso
  useEffect(() => {
    // Não redireciona se estiver em uma rota protegida
    if (idleTime >= MAX_IDLE_TIME && location.pathname !== '/' && !isProtectedRoute) {
      navigate('/');
    }
  }, [idleTime, MAX_IDLE_TIME, location.pathname, navigate, isProtectedRoute]);
  
  // Este componente não renderiza nada, apenas monitora a inatividade
  return null;
};

export default IdleMonitor;
